// Same observer as src/product-value/view.js. A block's `viewScript` is only
// enqueued on pages where that block actually renders, so Final CTA cannot rely
// on Product Value being present to animate its accent.
function initChromaReveal( el ) {
	const observer = new window.IntersectionObserver(
		( entries ) => {
			for ( const entry of entries ) {
				if ( entry.isIntersecting ) {
					// Swap, don't stack — see src/product-value/view.js.
					el.classList.remove( 'text-grey-100' );
					el.classList.add( 'chroma-text', 'chroma-sweep-animate' );
					observer.disconnect();
					break;
				}
			}
		},
		{ threshold: 0.4 }
	);
	observer.observe( el );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.chroma-reveal-accent' )
		.forEach( initChromaReveal );
} );
